/**
 * @fileoverview Mock API Handlers - 金價計算
 *
 * Mock 的 API Endpoints:
 *
 * 1. POST /gold/calculate
 *    功能: 批量計算商品價格
 *
 *    Request:
 *    ```json
 *    [
 *      {
 *        length: "S (5 X 8)",
 *        type: "normal",
 *        unit: "cm",
 *        way: "E",
 *        weight: "0.40"
 *      }
 *    ]
 *    ```
 *
 *    Response:
 *    ```json
 *    {
 *      "data": [
 *        { "price": 5234 },
 *        { "price": 8900 }
 *      ]
 *    }
 *    ```
 *
 *    說明: 價格隨機生成，範圍 1,000-10,000 元
 */

import { rest } from "msw";

// 從環境變數獲取 API URL（去掉結尾的斜線）
const API_BASE_URL = process.env.VUE_APP_API_URL;

export const goldCalculateHandler = rest.post(
  `${API_BASE_URL}gold/calculate`,
  async (req, res, ctx) => {
    const orderItems = await req.json();

    // 為每個訂單項目生成隨機價格
    const priceResults = orderItems.map(() => {
      const price = generatePrice();
      return { price };
    });

    // 模擬 API 回應格式
    const response = { data: priceResults };

    return res(ctx.status(200), ctx.json(response));
  }
);

// Mock 配置：價格範圍
const MOCK_CONFIG = {
  MIN_PRICE: 1000, // 最低價格
  MAX_PRICE: 10000, // 最高價格
};

// 生成隨機價格（1000~10000 之間）
function generatePrice() {
  const { MIN_PRICE, MAX_PRICE } = MOCK_CONFIG;
  return Math.floor(Math.random() * (MAX_PRICE - MIN_PRICE + 1)) + MIN_PRICE;
}
